import { render, staticRenderFns } from "./itemcatalog.vue?vue&type=template&id=29091e8a&scoped=true"
import script from "./itemcatalog.vue?vue&type=script&lang=js"
export * from "./itemcatalog.vue?vue&type=script&lang=js"
import style0 from "./itemcatalog.vue?vue&type=style&index=0&id=29091e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29091e8a",
  null
  
)

export default component.exports